var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCapturedFrameRateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 29,
    viewBox: "0 0 34 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 29,
    rx: 3.91304,
    transform: "matrix(-1 0 0 1 34 0)",
    fill: "#F6939D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2292 14.4458H16.7762C16.1972 14.4458 15.7266 14.9164 15.7266 15.4954V21.9485C15.7266 22.5275 16.1972 22.9981 16.7762 22.9981H23.2292C23.8082 22.9981 24.2789 22.5275 24.2789 21.9485V15.4954C24.2789 14.9181 23.8082 14.4458 23.2292 14.4458ZM16.7762 21.9501V15.497H23.2292V21.9501H16.7762Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7246 12.2999V20.2538H13.7742V12.2999C13.7742 12.0104 14.0104 11.7742 14.2999 11.7742H22.2538V10.7246H14.2999C13.4314 10.7246 12.7246 11.4314 12.7246 12.2999Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7723 8.56744C10.7723 8.27794 11.0084 8.04182 11.2979 8.04182H20.0006V6.99219H11.2979C10.4294 6.99219 9.72266 7.69895 9.72266 8.56744V17.2701H10.7723V8.56744Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapturedFrameRateIcon);
export default __webpack_public_path__ + "static/media/capturedFrameRateIcon.56ff1551593c3a82d350d8cc1e277b61.svg";
export { ForwardRef as ReactComponent };